<template>
  <div>
    <el-tabs
      v-model="activeTab"
      type="border-card"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(88, 85, 85, 0.8)"
      @tab-click="handleClick"
    >
      <el-tab-pane :label="$t('stock.tabtitle')" name=":product">
        <data-tables-server
          :data="stockList"
          :total="total"
          @query-change="tableQueryChange"
          :pagination-props="{ pageSizes: [10, 50], layout: 'sizes, total, prev, pager, next' }"
          :table-props="{ stripe: false, 'row-class-name': tableRowClassName }"
          layout="tool, table, pagination"
        >
          <el-row slot="tool" :gutter="0">
            <el-col :span="20">
              <el-form :inline="true" size="small">
                <el-form-item>
                  <el-input v-model="codebars" :placeholder="$t('stock.saleCodeTip')" @keyup.enter.native="search(1)"></el-input>
                </el-form-item>
                <!-- <el-form-item>
									<el-select v-model="typestatusid"  :placeholder="$t('stock.choosestatus')">
									    <el-option :key="0" :label="$t('stock.statetypeone')" :value="0"></el-option>
										<el-option :key="1" :label="$t('stock.statetypetwo')" :value="1"></el-option>
									</el-select>
								</el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="search(1)">{{ $t("stock.search") }}</el-button>
<!--                  <el-button type="primary" icon="el-icon-download" @click="exportexl(1)" :loading="this.isLoadingExport">{{-->
<!--                    $t("stock.exportdata")-->
<!--                  }}</el-button>-->
                </el-form-item>
                <el-form-item>
                  <!-- <button style="background: #409EFF;padding:8px 10px;border: none;color: #FFFFFF;border-radius:3px;" @click="exportexl(1)">{{ $t("stock.exportdata") }}</button> -->
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-table-column prop="codebars" :label="$t('stock.saleCode')" align="center"></el-table-column>
          <el-table-column prop="quantity2" :label="$t('stock.maxLengthofABlock')" align="center"></el-table-column>
<!--          <el-table-column prop="brand" :label="$t('stock.brand')" align="center"></el-table-column>-->
<!--          <el-table-column prop="clearance" :label="$t('stock.clearance')" align="center"></el-table-column>-->
          <!--清货-->
<!--图样-->
<!--          <el-table-column v-if="category == 'vitality'" :label="$t('stock.photo')" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <p @click="lookview(stockList[scope.$index])">{{ stockList[scope.$index].lookviewphoto }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <!--清货-->
          <!-- <el-table-column prop="docDueDate" :label="$t('stock.latestReplenishmentDate')" :formatter="dateFormatter" align="center"></el-table-column> -->
          <el-table-column prop="docDueDate" :label="$t('stock.latestReplenishmentDate')" align="center"></el-table-column>

<!--          <el-table-column :label="$t('stock.operation')">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip effect="dark" :content="$t('stock.details')" placement="bottom">-->
<!--                <i class="iconfont icon-chakan" @click="showDetails(scope.row, 1)"></i>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </data-tables-server>

        <el-dialog width="550px" top="20px" :visible.sync="dialogDetailFormVisible" :title="$t('stock.details')">
          <el-tabs type="border-card">
            <el-tab-pane :label="$t('stock.basicInformation')">
              <ul class="task-list" v-for="item in stockDetails">
                <li>{{ $t("stock.saleCode") }}:{{ item.codebars }}</li>
                <li>{{ $t("stock.yarn") }}: {{ item.yarn }}</li>
                <li>{{ $t("stock.component") }}: {{ item.component }}</li>
                <li>{{ $t("stock.weight") }}: {{ item.weight }}</li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </el-dialog>
        <!-- 添加蒙层 -->
        <div class="loading-overlay" v-if="isProductLoading">
          <el-spinner></el-spinner>
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('stock.tabtitle_pic')" name=":picture">
        <!-- <el-tab-pane :label="$t('stock.tabtitle_pic')" v-if="this.category=='vitality'"> -->
        <data-tables-server
          :data="recordslist"
          :total="picturetotal"
          @query-change="tablePictureChange"
          :pagination-props="{ pageSizes: [10, 50], layout: 'sizes, total, prev, pager, next' }"
          :table-props="{ stripe: false, 'row-class-name': tableRowClassName }"
          layout="tool, table, pagination"
        >
          <el-row slot="tool" :gutter="0">
            <el-col :span="20">
              <el-form :inline="true" size="small">
                <el-form-item>
                  <span style="color: red; margin-right: 10px">*</span>
                  <el-select v-model="picturecode" style="width: 230px" filterable :placeholder="$t('stock.pictureCoding')" @change="search(2)">
                    <el-option v-for="item in picturenum" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item>
									<el-select v-model="typestatusidtwo"  :placeholder="$t('stock.choosestatus')">
										<el-option :key="0" :label="$t('stock.statetypeone')" :value="0"></el-option>
										<el-option :key="1" :label="$t('stock.statetypetwo')" :value="1"></el-option>
									</el-select>
								</el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="search(2)">{{ $t("stock.search") }}</el-button>
<!--                  <el-button type="primary" icon="el-icon-download" @click="exportexl(2)" :loading="this.isLoadingExport">{{-->
<!--                    $t("stock.exportdata")-->
<!--                  }}</el-button>-->
                </el-form-item>
                <el-form-item>
                  <!--<button style="background: #409EFF;padding:8px 10px;border: none;color: #FFFFFF;border-radius:3px;" @click="exportexl(2)">{{ $t("stock.exportdata") }}</button>-->
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-table-column prop="codebars" :label="$t('stock.saleCode')" align="center"></el-table-column>
          <el-table-column prop="quantity2" :label="$t('stock.maxLengthofABlock')" align="center"></el-table-column>
<!--          <el-table-column prop="brand" :label="$t('stock.brand')" align="center"></el-table-column>-->
<!--          <el-table-column prop="clearance" :label="$t('stock.clearance')" align="center"></el-table-column>-->
<!--          &lt;!&ndash;清货&ndash;&gt;-->
<!--          <el-table-column :label="$t('stock.photo')" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <p @click="lookview(recordslist[scope.$index])">{{ recordslist[scope.$index].lookviewphoto }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="docDueDate" :label="$t('stock.latestReplenishmentDate')" align="center"></el-table-column>

<!--          <el-table-column :label="$t('stock.operation')">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip effect="dark" :content="$t('stock.details')" placement="bottom">-->
<!--                <i class="iconfont icon-chakan" @click="showDetails(scope.row, 2)"></i>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </data-tables-server>

        <el-dialog width="550px" top="20px" :visible.sync="dialogDetailbookVisible" :title="$t('stock.details')">
          <el-tabs type="border-card">
            <el-tab-pane :label="$t('stock.basicInformation')">
              <!-- <ul class="task-list">
								<li>{{ $t("stock.saleCode") }}: {{ stockDetails.codebars }}</li>
								<li>{{ $t("stock.yarn") }}: {{ stockDetails.yarn }}</li>
								<li>{{ $t("stock.component") }}: {{ stockDetails.component }}</li>
								<li>{{ $t("stock.weight") }}: {{ stockDetails.weight }}</li>
							</ul> -->
              <ul class="task-list" v-for="item in stockDetails">
                <li>{{ $t("stock.saleCode") }}:{{ item.codebars }}</li>
                <li>{{ $t("stock.yarn") }}: {{ item.yarn }}</li>
                <li>{{ $t("stock.component") }}: {{ item.component }}</li>
                <li>{{ $t("stock.weight") }}: {{ item.weight }}</li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </el-dialog>
        <!-- 添加蒙层 -->
        <div class="loading-overlay" v-if="isPictureLoading">
          <el-spinner></el-spinner>
        </div>
      </el-tab-pane>

      <el-tab-pane :label="$t('stock.tabtitle_sample')" name=":sample">
        <!-- <el-tab-pane :label="$t('stock.tabtitle_sample')" v-if="this.category=='vitality'"> -->
        <data-tables-server
          :data="recordsamplelist"
          :total="sampletotal"
          :hide-on-single-page="valueshow"
          @query-change="tablesampleChange"
          :pagination-props="{ pageSizes: [10, 50], layout: 'sizes, total, prev, pager, next' }"
          :table-props="{ stripe: false, 'row-class-name': tableRowClassName }"
          layout="tool, table, pagination"
        >
          <el-row slot="tool" :gutter="0">
            <el-col :span="20">
              <el-form :inline="true" size="small">
                <span style="color: red; margin-right: 10px; margin-top: 6px; display: inline-block">*</span>
                <el-form-item>
                  <el-select v-model="samplecode" style="width: 230px" filterable :placeholder="$t('stock.sampleCoding')" @change="search(3)">
                    <el-option v-for="item in samplenum" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item>
									<el-select v-model="typestatusidthree" :placeholder="$t('stock.choosestatus')">
									   <el-option :key="0" :label="$t('stock.statetypeone')" :value="0"></el-option>
									   <el-option :key="1" :label="$t('stock.statetypetwo')" :value="1"></el-option>
									</el-select>
								</el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="search(3)">{{ $t("stock.search") }}</el-button>
<!--                  <el-button type="primary" icon="el-icon-download" @click="exportexl(3)" :loading="this.isLoadingExport">{{-->
<!--                    $t("stock.exportdata")-->
<!--                  }}</el-button>-->
                </el-form-item>
                <el-form-item>
                  <!--<el-button type="primary" icon="el-icon-download" @click="exportexl(3)">{{ $t("stock.exportdata") }}</el-button>-->
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>

          <el-table-column prop="codebars" :label="$t('stock.saleCode')" align="center"></el-table-column>
          <el-table-column prop="quantity2" :label="$t('stock.maxLengthofABlock')" align="center"></el-table-column>
<!--          <el-table-column prop="brand" :label="$t('stock.brand')" align="center"></el-table-column>-->
<!--          <el-table-column prop="clearance" :label="$t('stock.clearance')" align="center"></el-table-column>-->
          <!--清货-->
<!--          <el-table-column :label="$t('stock.photo')" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <p @click="lookview(recordsamplelist[scope.$index])">{{ recordsamplelist[scope.$index].lookviewphoto }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="docDueDate" :label="$t('stock.latestReplenishmentDate')" align="center"></el-table-column>

<!--          <el-table-column :label="$t('stock.operation')">-->
<!--            <template slot-scope="scope">-->
<!--              <el-tooltip effect="dark" :content="$t('stock.details')" placement="bottom">-->
<!--                <i class="iconfont icon-chakan" @click="showDetails(scope.row, 3)"></i>-->
<!--              </el-tooltip>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </data-tables-server>
        <el-dialog width="550px" top="20px" :visible.sync="dialogDetailsamVisible" :title="$t('stock.details')">
          <el-tabs type="border-card">
            <el-tab-pane :label="$t('stock.basicInformation')">
              <ul class="task-list" v-for="item in stockDetails">
                <li>{{ $t("stock.saleCode") }}:{{ item.codebars }}</li>
                <li>{{ $t("stock.yarn") }}: {{ item.yarn }}</li>
                <li>{{ $t("stock.component") }}: {{ item.component }}</li>
                <li>{{ $t("stock.weight") }}: {{ item.weight }}</li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </el-dialog>
        <!-- 添加蒙层 -->
        <div class="loading-overlay" v-if="isSampleLoading">
          <el-spinner></el-spinner>
        </div>
      </el-tab-pane>

      <!-- 运单查询 -->
      <el-tab-pane :label="$t('stock.tabtitle_express_delivery')" name=":delivery">
        <data-tables-server
          :data="deliveryList"
          @query-change="tableQueryChange"
          :pagination-props="{ layout: '' }"
          :table-props="{ stripe: false }"
          layout="tool, table, pagination"
        >
          <el-row slot="tool" :gutter="0">
            <el-col :span="20">
              <el-form :inline="true" size="small">
                <el-form-item>
                  <el-input
                    class="deliveryCodeInput"
                    v-model="deliveryCode"
                    :placeholder="$t('stock.deliveryCodeTip')"
                    @keyup.enter.native="search(4)"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search(4)">{{ $t("stock.search") }}</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <el-table-column prop="invoiceNo" :label="$t('stock.doNo')" align="center"></el-table-column>
          <!--发货单号-->
          <el-table-column prop="refSoNo" :label="$t('stock.refSoNo')" align="center"></el-table-column>
          <!--销售订单号-->
          <el-table-column prop="expressNo" :label="$t('stock.expressNo')" align="center">
            <!--运单号-->
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click.stop="expressHandler(scope.row)">
                {{ scope.row.expressNo.includes("DO") ? "" : scope.row.expressNo }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="remarks" :label="$t('stock.remarks')" align="center"></el-table-column>
          <!--备注-->
        </data-tables-server>
        <!-- 添加蒙层 -->
        <div class="loading-overlay" v-if="isDeliveryLoading">
          <el-spinner></el-spinner>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getStockList,
  getStockDetails,
  getbooknums,
  getsearchbooknums,
  getsamplenums,
  getsearchsamplenums,
  getexport,
  getsearchhasbook,
  getDeliveyList,
} from "@/api/module/stock";
import { ssopermission, exportStock } from "@/api/accessPermission.js";
import bus from "../../bus/eventBus.js";
export default {
  name: "stock",
  components: {},
  data() {
    return {
      activeTab: ":product",
      dialogDetailFormVisible: false,
      dialogDetailbookVisible: false,
      dialogDetailsamVisible: false,
      ifbool: false, //弹出框展示与否
      isLoadingExport: false,
      dataimgurl: "",
      stockList: [],
      deliveryList: [], // 运单列表信息
      currentPage: 1,
      currentpicPage: 1,
      currentsamPage: 1,
      // currentDeliveryPage: 1,  // 运单查询Tab当前页
      pageSize: 10,
      pagepicSize: 10,
      pagesamSize: 10,
      // pageDeliverySize: 10,  // 运单查询Tab每页展示数
      stockDetails: {},
      typestatusid: 0,
      typestatusidtwo: 0,
      typestatusidthree: 0,
      total: 0,
      picturetotal: 0,
      sampletotal: 0,
      // deliveryTotal: 0, // 运单查询Tab总行数
      codebars: "",
      deliveryCode: "", // 运单查询输入的编码
      picturenum: [],
      samplenum: [],
      picturecode: "",
      samplecode: "",
      recordslist: [],
      recordsamplelist: [],
      loading: false,
      isProductLoading: false,
      isPictureLoading: false,
      isSampleLoading: false,
      isDeliveryLoading: false,
      value: "",
      category: "",
      valueshow: false,
      langu: "",
      tabtitle: "",
      appid: "",
      codenumber: [],
      codelist: ["42198/193", "234", "666"],
    };
  },
  computed: {},
  async created() {
    // console.log(process.env.VUE_APP_TYPE);
    // console.log(this.langu)
    // console.log('localStorage.getItem(lang)',localStorage.getItem('lang'));
    this.category = process.env.VUE_APP_TYPE;
    // await this.getStocks(this.currentPage, this.pageSize);
    if (this.category == "vitality") {
      this.$i18n.locale = "zh";
      localStorage.setItem("lang", "zh");
      this.langu = "China";
      (this.appid = "001"), await this.getpicture(); //下拉列表画册样本编码
      await this.getsample(); //下拉列表样本查询编码
    } else if (this.category == "vmb") {
      this.$i18n.locale = "en";
      localStorage.setItem("lang", "en");
      this.langu = "English";
      this.appid = "002";
      await this.getpicture(); //下拉列表画册样本编码
      await this.getsample(); //下拉列表样本查询编码
    }
    // console.log(this.langu)
  },
  mounted() {
    this.activeTab = this.$route.params.tab || this.activeTab;
    // 运单查询邮件URL示例：https://stock.vitalitytex.com.cn/#/main:delivery?invoiceNo=SO7407，域名取环境变量
    if (this.$route.params && this.$route.params.tab === ":delivery" && this.$route.query.invoiceNo) {
      this.deliveryCode = this.$route.query.invoiceNo;
      this.getDelivery();
    }
  },
  methods: {
    async lookphoto(data, list, tag) {
      //              console.log(data);
      // console.log(this.codelist.length)
      let stockListaa = [];
      stockListaa = list;
      // console.log(stockListaa)
      var that = this;
      let res = await getsearchhasbook({
        data,
      });
      if (res.code == 0) {
        if (this.codelist.length > 0) {
          for (var y = 0; y < this.codelist.length; y++) {
            let data = this.codelist[y];
            // console.log(data)
            for (var i = 0; i < stockListaa.length; i++) {
              let item = stockListaa[i];
              if (data == item.codebars) {
                item.lookviewphoto = "查看";
              } else {
              }
            }
            this.$forceUpdate();
          }
        }
        if (tag == "产品码查询") {
          this.stockList = stockListaa;
          // console.log(this.stockList)
        } else if (tag == "画册查询") {
          this.recordslist = [];
          this.recordslist = stockListaa;
          this.$forceUpdate();
          // console.log(this.recordslist)
        } else if (tag == "样本查询") {
          this.recordsamplelist = [];
          this.recordsamplelist = stockListaa;
          this.$forceUpdate();
          // console.log(this.recordsamplelist)
        }
      }
    },
    //查看图片
    lookview(item) {
      // console.log(item)
      this.dataimgurl = "https://qr.vitalitytex.com.cn/products/qr?code=" + item.codebars + "&" + "appid=" + this.appid;
      // console.log(this.dataimgurl)
      window.open(this.dataimgurl, "_blank");
    },
    closed() {
      this.ifbool = false;
    },
    handleClick(tab, event) {
      this.$router.push(`/main${tab.name}`);
      // console.log(tab.label)
      this.$forceUpdate();
      let obj = {
        page: 1,
        pageSize: 10,
      };
      this.isLoadingExport = false;

      if (tab.label == "产品码查询" || tab.label == "By Product") {
        this.tableQueryChange(obj);
      }
      if (tab.label == "画册查询" || tab.label == "By LOOKBOOK") {
        // console.log('By LOOKBOOK 画册')
        this.picturetotal = 1;
      }
      if (tab.label == "样本查询" || tab.label == "By BUNCH") {
        // console.log('By BUNCH 样本')
        this.sampletotal = 1;
      }
      // console.log(this.picturetotal)
      // console.log(this.sampletotal)
      // this.getsearchpicture(this.currentpicPage, this.pagepicSize, this.picturecode); //画册查询
      // this.getsearchsample(this.currentsamPage, this.pagesamSize, this.samplecode); //样本查询
    },
    exportexl(data) {
      if (localStorage.getItem("lang") == "zh") {
        this.langu = "China";
      } else if (localStorage.getItem("lang") == "en") {
        this.langu = "English";
      }
      this.isLoadingExport = true;
      switch (data) {
        case 1:
          this.exportCommonHandle(data, this.codebars, this.langu, "产品码查询导出");
          break;
        case 2:
          if (this.picturecode == "") {
            this.$message({
              message: "画册编码不能为空！",
              type: "error",
            });
            return false;
          }
          this.exportCommonHandle(data, this.picturecode, this.langu, "画册查询导出");
          break;
        case 3:
          if (this.samplecode == "") {
            this.$message({
              message: "样本编码不能为空！",
              type: "error",
            });
            return false;
          }
          this.exportCommonHandle(data, this.samplecode, this.langu, "样本查询导出");
          break;

        default:
          break;
      }
    },
    exportCommonHandle(data, code, langu, excelTitle) {
      exportStock(data, code, langu)
        .then((res) => {
          // console.log(res);
          this.isLoadingExport = false;
          var blob = new Blob([res]);
          var url = window.URL.createObjectURL(blob);
          var aLink = document.createElement("a");
          aLink.style.display = "none";
          aLink.href = url;
          aLink.download = excelTitle + ".xlsx"; //下载后文件名
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: "抛出异常！",
          });
          this.isLoadingExport = false;
        });
    },
    async getStocks(currentPage, pageSize) {
      this.isProductLoading = true;
      if (localStorage.getItem("lang") == "zh") {
        this.langu = "China";
      } else if (localStorage.getItem("lang") == "en") {
        this.langu = "English";
      }
      var that = this;
      let res = await getStockList(currentPage, pageSize, {
        codebars: this.codebars,
        stockStatus: this.typestatusid,
        language: this.langu,
      });
      if (res.code == '-100') {
        this.isProductLoading = false;
        alert(res.message || '暂无此编号信息！')
      }
      if (res.code == 0) {
        // console.log(res.data.records);
        // console.log(localStorage.getItem('lang'));
        this.isProductLoading = false;
        this.total = res.data.total;
        if (this.total > 0) {
          this.stockList = res.data.records.map(function (e, i) {
            if (e.quantity != null) {
              // console.log('e.quantity.trim()',e.quantity.trim());
              if (e.quantity.trim() >= 70.0) {
                e.quantity = that.$t("stock.70over");
              }
            } else {
              e.quantity = "0";
            }
            e.category = process.env.VUE_APP_TYPE;
            return e;
          });
        } else {
          this.stockList = [];
        }
        // console.log(that.$t("stock.clearance"))
        let photocode = [];
        //					this.stockList[0].codebars='42198/193';
        //					this.stockList[5].codebars='42198/193';
        for (var i = 0; i < this.stockList.length; i++) {
          let item = this.stockList[i];
          // if (item.clearance == "Y") {
          //   //							item.clearance=that.$t("stock.clearanceContent");
          //   // item.docDueDate = "";
          // } else {
          //   item.clearance = "";
          // }
          photocode.push(item.codebars);
          this.codenumber = photocode;
          this.$forceUpdate();
        }
        if (this.category == "vitality") {
          this.lookphoto(this.codenumber, this.stockList, "产品码查询");
        }
      }
    },
    // 运单号查询
    async getDelivery() {
      this.isDeliveryLoading = true;
      var that = this;
      this.deliveryCode = this.deliveryCode.trim();
      let res = await getDeliveyList(this.deliveryCode);
      if (res.code == 0) {
        this.isDeliveryLoading = false;
        if (res.data && res.data.length > 0) {
          this.deliveryList = res.data.map(function (e, i) {
            if (!e.expressNo || e.expressNo.includes("DO")) {
              e.remarks = that.$t("stock.deliveryRemarks");
            }
            return e;
          });
        } else {
          this.deliveryList = [];
        }
      }
    },
    // 查询顺丰、德邦、Fedex物流信息
    expressHandler(item) {
      // 如果快递单号包含 "DO"，显示警告信息
      if (item.expressNo.includes("DO")) {
        this.$message({
          type: "warning",
          message: this.$t("stock.deliverySearchTip1"),
        });
        return;
      }
      // 顺丰-标快 6,顺丰-特快15, 德邦-物流自提 7,德邦-物流上门 8
      // Fedex 10, DHL 9, UPS 14
      const lang = localStorage.getItem("lang");
      const expressUrlMap = {
        6:
          lang === "zh"
            ? `https://www.sf-express.com/chn/sc/waybill/waybill-detail/${item.expressNo}`
            : `https://www.sf-international.com/cn/en/support/querySupport/waybill?No=${item.expressNo}`,
        15:
          lang === "zh"
            ? `https://www.sf-express.com/chn/sc/waybill/waybill-detail/${item.expressNo}`
            : `https://www.sf-international.com/cn/en/support/querySupport/waybill?No=${item.expressNo}`,
        7: `https://www.deppon.com/track/ordertrack?orderNumList=["${item.expressNo}"]`,
        8: `https://www.deppon.com/track/ordertrack?orderNumList=["${item.expressNo}"]`,
        9: `https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${item.expressNo}`,
        10: `https://www.fedex.com/fedextrack/?trknbr=${item.expressNo}`,
        14: `https://www.ups.com/track?loc=en_CN&requester=ST&tracknum=${item.expressNo}`,
      };

      const url = expressUrlMap[item.deliveryType];
      const opt = "postwindow";
      if (url) {
        window.open(url, "_blank", opt);
      } else {
        this.$message({
          type: "error",
          message: this.$t("stock.deliverySearchTip2"),
        });
      }
    },
    tableQueryChange(payload) {
      if (!this.codebars) return;
      this.currentPage = payload.page;
      this.pageSize = payload.pageSize;
      this.getStocks(this.currentPage, this.pageSize);
    },
    tablePictureChange(payload) {
      // console.log(payload)
      //				console.log(parseInt("20"));

      this.currentpicPage = payload.page;
      this.pagepicSize = payload.pageSize;
      if (this.currentpicPage == "" || this.pagepicSize == "" || this.picturecode == "") return;
      this.getsearchpicture(this.currentpicPage, this.pagepicSize, this.picturecode, this.typestatusidtwo);
    },
    tablesampleChange(payload) {
      // console.log(payload)
      this.currentsamPage = payload.page;
      this.pagesamSize = payload.pageSize;
      if (this.currentsamPage == "" || this.pagesamSize == "" || this.samplecode == "") return;
      this.getsearchsample(this.currentsamPage, this.pagesamSize, this.samplecode, this.typestatusidthree);
    },
    search(data) {
      var value = sessionStorage.getItem("exportStatus");
      // console.log('value',value);
      switch (data) {
        case 1:
          this.getStocks(1, this.pageSize);
          break;
        case 2:
          this.getsearchpicture(1, this.pagepicSize, this.picturecode, this.typestatusidtwo, "search");
          break;
        case 3:
          this.getsearchsample(1, this.pagesamSize, this.samplecode, this.typestatusidthree, "search");
          break;
        case 4:
          this.getDelivery();
          break;
        default:
          break;
      }
    },
    async showDetails(row, data) {
      // console.log(data)
      if (data == 1) {
        this.dialogDetailFormVisible = true;
      } else if (data == 2) {
        this.dialogDetailbookVisible = true;
      } else {
        this.dialogDetailsamVisible = true;
      }
      let res = await getStockDetails(row.codebars);
      if (res.code == "0") {
        this.stockDetails = res.data;
      }
    },
    //查询所有的样本画册编码
    async getpicture() {
      var that = this;
      let res = await getbooknums({});
      if (res.code == 0) {
        // console.log(res)
        var arr = [];
        for (var i = 0; i < res.data.length; i++) {
          var data = res.data[i];
          let codenumber = {
            label: "",
            value: "",
          };
          codenumber.label = data;
          codenumber.value = data;
          arr.push(codenumber);
        }
        this.picturenum = arr;
      }
    },
    async getsearchpicture(currentPage, pageSize, picturecode, stockStatus, tag) {
      if (localStorage.getItem("lang") == "zh") {
        this.langu = "China";
      } else if (localStorage.getItem("lang") == "en") {
        this.langu = "English";
      }
      let language = this.langu;
      if (picturecode == "" && tag == "search") {
        this.$message({
          message: "画册编码不能为空！",
          type: "error",
        });
      } else {
        // console.log('language',language);
        this.isPictureLoading = true;
        var that = this;
        let res = await getsearchbooknums(currentPage, pageSize, picturecode, stockStatus, language, {});
        if (res.code == 0) {
          // console.log(res)
          this.isPictureLoading = false;
          this.picturetotal = res.data.total;
          if (this.picturetotal > 0) {
            this.recordslist = res.data.records.map(function (e, i) {
              if (e.quantity != null) {
                // if(e.quantity.trim() == "40over") {
                // 	e.quantity = that.$t("stock.40over");
                // }
                // if(e.quantity.trim() == "50over") {
                // 	e.quantity = that.$t("stock.50over");
                // }
                // if(e.quantity.trim() == "60over") {
                // 	e.quantity = that.$t("stock.60over");
                // }
                // if(e.quantity.trim() == "70over") {
                // 	e.quantity = that.$t("stock.70over");
                // }
                // if(e.quantity.trim() == "endOfSale") {
                // 	e.quantity = that.$t("stock.endOfSale");
                // }
                // if(e.quantity.trim() == "supplying") {
                // 	e.quantity = that.$t("stock.supplying");
                // }
                if (e.quantity.trim() >= 70.0) {
                  e.quantity = that.$t("stock.70over");
                }
              } else {
                e.quantity = "0";
              }
              return e;
            });
          } else {
            this.recordslist = [];
          }
          let photocode = [];
          for (var i = 0; i < this.recordslist.length; i++) {
            let item = this.recordslist[i];
            // if (item.clearance == "Y") {
            //   //								item.clearance=that.$t("stock.clearanceContent");
            //   item.docDueDate = "";
            // } else {
            //   item.clearance = "";
            // }
            photocode.push(item.codebars);
            this.codenumber = photocode;
          }
          if (this.category == "vitality") {
            this.lookphoto(this.codenumber, this.recordslist, "画册查询");
          }
        }
      }
    },
    async getsample() {
      var that = this;
      let res = await getsamplenums({});
      if (res.code == 0) {
        // console.log(res);
        var arr = [];
        for (var i = 0; i < res.data.length; i++) {
          var data = res.data[i];
          let codenumber = {
            label: "",
            value: "",
          };
          codenumber.label = data;
          codenumber.value = data;
          arr.push(codenumber);
        }
        this.samplenum = arr;
      }
    },
    async getsearchsample(currentPage, pageSize, samplecode, stockStatus, tag) {
      if (localStorage.getItem("lang") == "zh") {
        this.langu = "China";
      } else if (localStorage.getItem("lang") == "en") {
        this.langu = "English";
      }
      let language = this.langu;
      if (samplecode == "" && tag == "search") {
        this.$message({
          message: "样本编码不能为空！",
          type: "error",
        });
      } else {
        this.isSampleLoading = true;
        var that = this;
        let res = await getsearchsamplenums(currentPage, pageSize, samplecode, stockStatus, language, {});
        if (res.code == 0) {
          // console.log(res)
          this.isSampleLoading = false;
          this.sampletotal = res.data.total;
          if (this.sampletotal > 0) {
            this.recordsamplelist = res.data.records.map(function (e, i) {
              if (e.quantity == null) {
                e.quantity = "0";
              }
              // if(e.quantity.trim() == "40over") {
              // 	e.quantity = that.$t("stock.40over");
              // }
              // if(e.quantity.trim() == "50over") {
              // 	e.quantity = that.$t("stock.50over");
              // }
              // if(e.quantity.trim() == "60over") {
              // 	e.quantity = that.$t("stock.60over");
              // }
              // if(e.quantity.trim() == "70over") {
              // 	e.quantity = that.$t("stock.70over");
              // }
              // if(e.quantity.trim() == "endOfSale") {
              // 	e.quantity = that.$t("stock.endOfSale");
              // }
              // if(e.quantity.trim() == "supplying") {
              // 	e.quantity = that.$t("stock.supplying");
              // }
              if (e.quantity.trim() >= 70.0) {
                e.quantity = that.$t("stock.70over");
              }
              return e;
            });
          } else {
            this.recordsamplelist = [];
          }
          let photocode = [];
          for (var i = 0; i < this.recordsamplelist.length; i++) {
            let item = this.recordsamplelist[i];
            // if (item.clearance == "Y") {
            //   // item.clearance=that.$t("stock.clearanceContent");
            //   item.docDueDate = "";
            // } else {
            //   item.clearance = "";
            // }
            photocode.push(item.codebars);
            this.codenumber = photocode;
          }
          // if(this.category=='vitality'){
          this.lookphoto(this.codenumber, this.recordsamplelist, "样本查询");
          // }
        }
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.quantity.trim() == "70+") {
        return "green_row";
      }
      if (row.quantity.trim() == "停售" || row.quantity.trim() == "Stop selling") {
        return "red_row";
      }
    },
    dateFormatter(row, column) {
      if (row.docDueDate != null && row.docDueDate != "" && row.docDueDate.length > 10) {
        return row.docDueDate.substring(0, 10);
      }
    },
  },
};
</script>
<style scope lang="scss">
.el-table .green_row {
  color: rgb(40, 177, 40);
}

.el-table .red_row {
  color: rgb(214, 45, 45);
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(88, 85, 85, 0.8);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-tab-pane {
  position: relative; /* 设置相对定位，以便蒙层可以绝对定位于它上方 */
}
.deliveryCodeInput {
  width: 250px;
}
.task-list {
  li {
    margin-top: 10px;
  }
}
.el-col-20 {
  width: 100%;
}
.cell p {
  cursor: pointer;
}
</style>
